import { createElement as _createElement } from "react";
import React from "react";
//import customTypes from "@project/enums/contentsCustomType";
import ContentsTypes from "@shared/enums/contentsTypes";
import ArticleTitle from "@project/components/ArticleTitle";
import PresentationBox from "@project/components/PresentationBox";
import SubPage from "@shared/components/contents/subPage/SubPage";
import { formatPageData } from "@frontoffice/utils/templates/formatPageData";
import SubpageSearch from "@project/components/SubpageSearch";
import BlockWithTitle from "@project/components/BlockWithTitle/BlockWithTitle";
import TextBlockWithTitle from "@project/components/TextBlockWithTitle/TextBlockWithTitle";
import DescriptionCardWithLogo from "@project/components/DescriptionCardWithLogo/DescriptionCardWithLogo";
import ContactForm from "@project/components/ContactForm/ContactForm";
import Mailto from "@project/components/Mailto";
import Iframe from "@project/components/Iframe/Iframe";
import customTypes from "@project/enums/contentsCustomTypes.enum";
import ProductBlock from "@project/components/ProductBlock/ProductBlock";
import ContactBlock from "@project/components/ContactBlock/ContactBlock";
import DescriptionSection from "@project/components/DescriptionSection/DescriptionSection";
import SolutionCard from "@project/components/SolutionCard/SolutionCard";
import OfferingCard from "@project/components/OfferingCard/OfferingCard";
import ColumnsWithIcon from "@project/components/ColumnsWithIcon/ColumnsWithIcon";
import StatCard from "@project/components/StatCard/StatCard";
import DescriptorTabsComponent from "@project/components/TabsComponent/DescriptionTabsComponent";
import IllustrationTabPanel from "@project/components/IllustrationTabPanel/IllustrationTabPanel";
import DescriptionService from "@project/components/DescriptionService";
import WitnessCard from "@project/components/WitnessCard";
import OfferPresentationCard from "@project/components/OfferPresentationCard/OfferPresentationCard";
import InfosBlock from "@project/components/InfosBlock/InfosBlock";
import ListWrap from "@project/components/ListWrap/ListWrap";
import ListInfos from "@project/components/ListInfos/ListInfos";
import CardPrice from "@project/components/CardPrice/CardPrice";
import CardLabel from "@project/components/CardLabel/CardLabel";
import Steps from "@project/components/Steps";
import ColorImageBlock from "@project/components/ColorImageBlock";
import GradientButton from "@project/components/Button/GradientButton";
const getDynamicComponent = ({ type, value, id, index }) => {
    switch (type) {
        case customTypes.ARTICLE_SECTION:
            return _createElement(ArticleTitle, { ...value, key: id });
        case customTypes.PRESENTATION_BOX:
            return _createElement(PresentationBox, { ...value, key: id });
        case customTypes.CARD_LABEL:
            return _createElement(CardLabel, { ...value, key: id });
        case customTypes.OFFER_PRESENTATION_CARD:
            return _createElement(OfferPresentationCard, { ...value, key: id });
        case customTypes.INFOS_BLOCK:
            return _createElement(InfosBlock, { ...value, key: id });
        case customTypes.LIST_WRAP:
            return _createElement(ListWrap, { ...value, key: id });
        case customTypes.LIST_INFOS:
            return _createElement(ListInfos, { ...value, key: id });
        case customTypes.CARD_PRICE:
            return _createElement(CardPrice, { ...value, key: id });
        case customTypes.WITNESS_CARD:
            return _createElement(WitnessCard, { ...value, key: id });
        case ContentsTypes.SUBPAGE: {
            const { page } = value || {};
            const { image } = page || {};
            return (_createElement(SubPage, { ...value, page: { ...formatPageData(page), image }, pageVersion: page, key: id, index: index }));
        }
        case customTypes.BLOCK_WITH_TITLE:
            return _createElement(BlockWithTitle, { ...value, key: id });
        case customTypes.TEXT_BLOCK_WITH_TITLE:
            return _createElement(TextBlockWithTitle, { ...value, key: id });
        case customTypes.COLOR_IMAGE_BLOCK:
            return _createElement(ColorImageBlock, { ...value, key: id });
        case customTypes.DESCRIPTION_SERVICE_CARD:
            return _createElement(DescriptionService, { ...value, key: id });
        case customTypes.GRADIENT_BUTTON:
            return _createElement(GradientButton, { ...value, key: id });
        case customTypes.DESCRIPTION_CARD_WITH_LOGO:
            return _createElement(DescriptionCardWithLogo, { ...value, key: id });
        case customTypes.DESCRIPTION_TABS:
            return _createElement(DescriptorTabsComponent, { ...value, key: id });
        case customTypes.ILLUSTRATION_TABS:
            return _createElement(IllustrationTabPanel, { ...value, key: id });
        case customTypes.SUBPAGE_SEARCH:
            return _createElement(SubpageSearch, { ...value, key: id });
        case customTypes.STEPS:
            return _createElement(Steps, { ...value, key: id });
        case customTypes.CONTACT_FORM:
            return _createElement(ContactForm, { ...value, key: id });
        case customTypes.MAILTO: {
            return _createElement(Mailto, { ...value, contentId: id, key: id });
        }
        case customTypes.IFRAME:
            return _createElement(Iframe, { ...value, key: id });
        case customTypes.PRODUCT_BLOCK:
            return _createElement(ProductBlock, { ...value, key: id });
        case customTypes.CONTACT_BLOCK:
            return _createElement(ContactBlock, { ...value, key: id });
        case customTypes.DESCRIPTION_SECTION:
            return _createElement(DescriptionSection, { ...value, key: id });
        case customTypes.SOLUTION_TYPE_ORGANISATION:
            return _createElement(SolutionCard, { ...value, key: id });
        case customTypes.OFFERING_CARD:
            return _createElement(OfferingCard, { ...value, key: id });
        case customTypes.STAT_CARD:
            return _createElement(StatCard, { ...value, key: id });
        case customTypes.COLUMNS_WITH_ICON:
            return _createElement(ColumnsWithIcon, { ...value, key: id });
        case customTypes.COLUMN_WITH_ICON_ITEM:
        case customTypes.CARD_PRICE_ROW_ITEM:
        case customTypes.DESCRIPTION_SECTION_ITEM:
        case customTypes.DESCRIPTION_TABS_ITEM:
        case customTypes.ILLUSTRATION_TAB_ITEM:
        case customTypes.DESCRIPTION_SERVICES_ITEM:
        case customTypes.LIST_WRAP_ITEM:
        case customTypes.LIST_INFOS_ITEM:
        case customTypes.STEP:
            return { id, ...(value || {}) };
        default:
            return null;
    }
};
export default getDynamicComponent;
